// Cross-subdomain theme persistence.
//
// localStorage is per-origin, so a theme picked on vinassessment.com never
// reached the business subdomains (dealer.vinassessment.com) — a dark
// marketing visit handed off to a light dashboard. The `va_theme` cookie on
// the apex domain is the cross-subdomain source of truth; localStorage stays
// as a same-origin fallback for sessions that predate the cookie.
//
// The no-FOUC inline scripts in the HAML layouts duplicate the read side of
// this logic (they run before any bundle loads) — keep them in sync.

export function readThemeCookie(): boolean | null {
  try {
    const m = document.cookie.match(/(?:^|;\s*)va_theme=(dark|light)/);
    return m ? m[1] === 'dark' : null;
  } catch {
    return null;
  }
}

export function initialDark(): boolean {
  const fromCookie = readThemeCookie();
  if (fromCookie !== null) return fromCookie;
  try {
    return localStorage.getItem('darkMode') === 'true';
  } catch {
    return false;
  }
}

export function persistTheme(isDark: boolean): void {
  try {
    localStorage.setItem('darkMode', String(isDark));
  } catch {}
  try {
    const apex = window.location.hostname.split('.').slice(-2).join('.');
    document.cookie = `va_theme=${isDark ? 'dark' : 'light'}; domain=.${apex}; path=/; max-age=31536000; SameSite=Lax`;
  } catch {}
}
